import { render, staticRenderFns } from "./ItinevertBanner.vue?vue&type=template&id=60dc7765&scoped=true"
import script from "./ItinevertBanner.vue?vue&type=script&lang=js"
export * from "./ItinevertBanner.vue?vue&type=script&lang=js"
import style0 from "./ItinevertBanner.vue?vue&type=style&index=0&id=60dc7765&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dc7765",
  null
  
)

export default component.exports